// removed by extract-text-webpack-plugin
module.exports = {"container":"Map__container___2iB1brT","location":"Map__location___3zGJwgn","icon":"Map__icon___2YM1bP6","text":"Map__text___2e6HZNs","mapWrapper":"Map__mapWrapper___3gw-1_T"};